/* 一覧カードの「状態」ピッカー。

   やること:
     - 状態タブを押すと、フォームの variant id と表示価格を差し替える
     - 数量の上限をその状態の在庫数に合わせる
     - 在庫が無い状態は押せないようにする

   価格の文字列は Liquid 側で money フィルタを通したものを data-price に入れてある。
   JS で通貨を組み立てると書式がずれるので、ここでは差し替えるだけにする */
if (!customElements.get('card-condition-picker')) {
  customElements.define(
    'card-condition-picker',
    class CardConditionPicker extends HTMLElement {
      connectedCallback() {
        this.options = Array.from(this.querySelectorAll('.card-condition__option'));
        if (this.options.length === 0) return;

        this.idInput = this.querySelector('input[name="id"]');
        this.qtyInput = this.querySelector('input[name="quantity"]');
        this.submit = this.querySelector('.card-condition__submit');
        this.stockNote = this.querySelector('.card-condition__stock');

        // 価格はカード側 (price スニペット) にあるので、カードを辿って書き換える。
        // compare_at_price の <s> は書き換えたくないので span だけを対象にする
        const card = this.closest('.card-wrapper--product');
        this.priceTargets = card
          ? Array.from(card.querySelectorAll('.price span.price-item--regular, .price span.price-item--sale'))
          : [];

        this.options.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            this.select(btn);
          });
        });

        this.querySelectorAll('.card-condition__qty-btn').forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            this.step(parseInt(btn.dataset.step, 10) || 0);
          });
        });

        if (this.qtyInput) {
          this.qtyInput.addEventListener('change', () => this.clampQuantity());
        }

        const current = this.options.find((b) => b.getAttribute('aria-pressed') === 'true') || this.options[0];
        // 🔑 初期表示は範囲 (¥最安 - ¥最高) のまま。状態を選んだときだけ単価に差し替える
        this.apply(current, false);
      }

      select(btn) {
        if (btn.hasAttribute('disabled')) return;
        this.options.forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
        if (this.qtyInput) this.qtyInput.value = '1';
        this.apply(btn, true);
      }

      apply(btn, updatePrice) {
        this.current = btn;
        const available = btn.dataset.available === 'true';
        const max = parseInt(btn.dataset.max, 10) || 0;

        if (this.idInput) this.idInput.value = btn.dataset.variantId;

        if (this.qtyInput) {
          this.qtyInput.max = max > 0 ? String(max) : '1';
          this.qtyInput.disabled = !available;
          this.clampQuantity();
        }

        if (this.submit) {
          this.submit.disabled = !available;
          const span = this.submit.querySelector('span');
          if (span && window.variantStrings) {
            span.textContent = available ? window.variantStrings.addToCart : window.variantStrings.soldOut;
          }
        }

        if (this.stockNote) {
          this.stockNote.textContent = btn.dataset.stockNote || '';
        }

        if (updatePrice && btn.dataset.price) {
          this.priceTargets.forEach((el) => {
            el.textContent = btn.dataset.price;
          });
        }
      }

      step(delta) {
        if (!this.qtyInput || this.qtyInput.disabled) return;
        const max = parseInt(this.qtyInput.max, 10) || 1;
        const next = (parseInt(this.qtyInput.value, 10) || 1) + delta;
        this.qtyInput.value = String(Math.min(Math.max(next, 1), max));
        this.updateStepButtons();
      }

      clampQuantity() {
        if (!this.qtyInput) return;
        const max = parseInt(this.qtyInput.max, 10) || 1;
        const value = parseInt(this.qtyInput.value, 10) || 1;
        this.qtyInput.value = String(Math.min(Math.max(value, 1), max));
        this.updateStepButtons();
      }

      updateStepButtons() {
        const value = parseInt(this.qtyInput.value, 10) || 1;
        const max = parseInt(this.qtyInput.max, 10) || 1;
        this.querySelectorAll('.card-condition__qty-btn').forEach((btn) => {
          const step = parseInt(btn.dataset.step, 10) || 0;
          const blocked = this.qtyInput.disabled || (step < 0 && value <= 1) || (step > 0 && value >= max);
          btn.toggleAttribute('disabled', blocked);
        });
      }
    }
  );
}
